import React from "react";
import {
  useEditProjectMutation,
  useGetAllProjectsQuery,
} from "../../redux/features/projects/projectsApi";
import ProjectGridHeader from "./ProjectGridHeader";
import ProjectList from "./ProjectList";
import { useDrop } from "react-dnd";
import { toast } from "react-toastify";
import ProjectLoader from "../ui/ProjectLoader";

function ProjectGrid({ projectState, id }) {
  const {
    data: projects,
    isLoading: projectLoading,
    isError,
  } = useGetAllProjectsQuery();
  const [editProject, { isLoading: dragLoading }] = useEditProjectMutation();
  const filteredData = projects
    ?.filter((project) => project.projectState === projectState)
    .sort((a, b) => b.timeStamp - a.timeStamp);
  const [{}, dropRef] = useDrop(() => ({
    accept: "card",
    item: { id: id },
    drop: (item) => handleDrag(item),
  }));

  const handleDrag = async (item) => {
    if (projectState !== item.project.projectState) {
      try {
        await editProject({
          id: item.project.id,
          body: {
            projectState,
          },
        }).unwrap();
      } catch (error) {
        toast.error("Something went wrong");
      }
    }
  };

  let content;
  if (projectLoading) content = <ProjectLoader />;
  if (!projectLoading && isError)
    content = (
      <div className="w-full h-full flex justify-center items-center">
        <h1>Something Went wrong</h1>
      </div>
    );
  if (!projectLoading && !isError && projects.length === 0)
    content = (
      <div className="w-full h-full flex justify-center items-center">
        <h1>No projects to show</h1>
      </div>
    );

  if (!projectLoading && !isError && projects.length > 0)
    content = (
      <ProjectList projectState={projectState} filteredData={filteredData} />
    );

  return (
    <div className="flex flex-col flex-shrink-0 w-72" ref={dropRef}>
      <ProjectGridHeader
        projectState={projectState}
        noOfProjects={filteredData?.length}
      />
      {content}
    </div>
  );
}

export default ProjectGrid;
